module.exports = __webpack_public_path__ + "media/images/sp/banner/winter_campaign-e9f6d7fe17358bb962a7e69522210f68.png";